import { useQuery, useLazyQuery, useMutation } from '@apollo/client';
import * as Schema from '@sellermodules/saleschannel/services/graphql/schema';

const context = {
    context: { request: 'internal' },
};

const fetchPolicy = {
    fetchPolicy: 'cache-and-network',
};

export const getSellerStores = (options) => useLazyQuery(Schema.getSellerStores, {
    ...options,
    ...context,
    ...fetchPolicy,
});

export const getSellerStoresQuery = (options) => useQuery(Schema.getSellerStores, {
    ...options,
    ...context,
    ...fetchPolicy,
});

export const getMarketplaceWarehouse = (options) => useQuery(Schema.getMarketplaceWarehouse, {
    ...options,
    ...context,
    ...fetchPolicy,
});

export const csChannels = (variables) => useQuery(Schema.csChannels, {
    variables,
    ...context,
    ...fetchPolicy,
});

export const csGetChannelCredential = (options) => useQuery(Schema.csGetChannelCredential, {
    ...options,
    ...context,
    ...fetchPolicy,
});

export const csGetChannelCredentialLazy = (options) => useLazyQuery(Schema.csGetChannelCredential, {
    ...options,
    ...context,
    ...fetchPolicy,
});

export const csRegisterBrand = (options) => useMutation(Schema.csRegisterBrand, {
    ...options,
    ...context,
});

export const csConnectToChannel = (options) => useMutation(Schema.csConnectToChannel, {
    ...options,
    ...context,
});

export const csCreateStoreRequest = (options) => useMutation(Schema.csCreateStoreRequest, {
    ...options,
    ...context,
});

export const csStores = (options) => useLazyQuery(Schema.csStores, {
    ...options,
    ...context,
    ...fetchPolicy,
});

export const csStoresQuery = (options) => useQuery(Schema.csStores, {
    ...options,
    ...context,
    ...fetchPolicy,
});

export const csStoreRequests = (options) => useLazyQuery(Schema.csStoreRequests, {
    ...options,
    ...context,
    ...fetchPolicy,
});

export const csSyncStoreStatusConnected = (options) => useMutation(Schema.csSyncStoreStatusConnected, {
    ...options,
    ...context,
});

export const csDisconnectStore = (options) => useMutation(Schema.csDisconnectStore, {
    ...options,
    ...context,
});

export const csReconnectStore = (options) => useMutation(Schema.csReconnectStore, {
    ...options,
    ...context,
});

export const csCancelStoreRequest = (options) => useMutation(Schema.csCancelStoreRequest, {
    ...options,
    ...context,
});

export const getSellerLocByChannel = (variables) => useQuery(Schema.getSellerLocByChannel, {
    variables,
    ...context,
    ...fetchPolicy,
});

export const saveSellerLocByChannel = (options) => useMutation(Schema.saveSellerLocByChannel, {
    ...options,
    ...context,
});

export const csConfig = () => useLazyQuery(Schema.csConfig, {
    ...context,
    ...fetchPolicy,
});

export const csUpdateStore = (options) => useMutation(Schema.csUpdateStore, {
    ...options,
    ...context,
});

export default {
    getSellerStores,
    getSellerStoresQuery,
    getMarketplaceWarehouse,
    csChannels,
    csGetChannelCredential,
    csGetChannelCredentialLazy,
    csRegisterBrand,
    csConnectToChannel,
    csCreateStoreRequest,
    csStores,
    csStoresQuery,
    csStoreRequests,
    csSyncStoreStatusConnected,
    csDisconnectStore,
    csReconnectStore,
    csCancelStoreRequest,
    getSellerLocByChannel,
    saveSellerLocByChannel,
    csConfig,
    csUpdateStore,
};
